<template>
  <div class="nav_tabBar" v-if="!hideNav">
    <router-link to="/course" class="nav_item" :class="{nav_item_active: nav == '/'}">
      <img v-if="nav == 'course' || nav == '/'" src="../../assets/6@2x.png" alt>
      <img v-else src="../../assets/10@2x.png" alt>
      <span>课程</span>
    </router-link>
    <router-link to="/assessment" class="nav_item">
      <img v-if="nav == 'assessment'" src="../../assets/7@2x.png" alt>
      <img v-else src="../../assets/11@2x.png" alt>
      <span>考核</span>
    </router-link>
    <router-link to="/administration" class="nav_item">
      <img v-if="nav == 'administration'" src="../../assets/8@2x.png" alt>
      <img v-else src="../../assets/12@2x.png" alt>
      <span>管理</span>
    </router-link>
    <router-link to="/mine" class="nav_item">
      <img v-if="nav == 'mine'" src="../../assets/9@2x.png" alt>
      <img v-else src="../../assets/13@2x.png" alt>
      <span>我的</span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "v-tab-bar",
  data() {
    return {
      nav: "/",
      hideNav: false
    };
  },
  created() {
    
    // if(this.$route.path == '/perview' || this.$route.path == '/courseInfo' || this.$route.path == '/announcementDetail' || this.$route.path == '/userCenter' || this.$route.path == '/myCourse' || this.$route.path == '/myAssess'){
    //   this.hideNav = true;
    // }
    // if(this.$route.path != '/course' && this.$route.path != '/' && this.$route.path != '/assessment' && this.$route.path != '/administration' && this.$route.path != '/mine'){
    //   this.hideNav = true;
    // }
    if (this.$route.path == "/course") {
      this.nav = "course";
      // this.hideNav = false;
    } else if (this.$route.path == "/assessment") {
      this.nav = "assessment";
      // this.hideNav = false;
    } else if (this.$route.path == "/administration") {
      this.nav = "administration";
      // this.hideNav = false;
    } else if (this.$route.path == "/mine") {
      this.nav = "mine";
      // this.hideNav = false;
    }
    // this.$root.center.$on("hideNav", data => {
    //   this.hideNav = data;
    // });
  },
  methods: {},
  watch: {
    // $route(to, from) {
    //   if (to.path == "/course") {
    //     this.nav = "course";
    //     this.hideNav = false;
    //   } else if (to.path == "/assessment") {
    //     this.nav = "assessment";
    //     this.hideNav = false;
    //   } else if (to.path == "/administration") {
    //     this.nav = "administration";
    //     this.hideNav = false;
    //   } else if (to.path == "/mine") {
    //     this.nav = "mine";
    //     this.hideNav = false;
    //   }
    // }
  }
};
</script>

<style lang="scss">
a {
  color: #999;
  text-decoration: none;
}
.router-link-active {
  color: #333;
}
.nav_tabBar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-width: 500px;
  height: 49px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-top: 1px solid #eee;
  background-color: rgb(247, 247, 250);
  .nav_item {
    flex: 1;
    display: flex;
    font-size: 14px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.nav_item_active {
  color: #333;
}
</style>



// WEBPACK FOOTER //
// src/components/tabBar/tabBar.vue